import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Card, CardContent, Typography, Icon } from '@mui/material';
import { useMediaQuery } from '@material-ui/core';
import MDTypography from 'components/MDTypography';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import ApiCalls from "services/flick_erp_api_call";
import { candidatesList, optionValues } from "../candidates/candidatesSlice";
import { employeeList } from 'layouts/employees/employeesSlice';
import './position.css';
import { useTheme } from '@emotion/react';
import { ChevronLeft } from '@mui/icons-material';
import MDButton from 'components/MDButton';
import { ExistingCandidateList, CandidateDetails, RenderCandidatesList } from './renderList';
import { AddCandidateDialog, CandidateInformationDialog, EmailDialog, ScheduleInterviewDialog } from './positionDialogs';
import colors from 'assets/theme/base/colors';
import rgba from 'assets/theme/functions/rgba';

function Position({ positionData, setIsCard, setJobAdvertisementPayload, modulePermissions, permissions }) {
    const location = useLocation();
    const position = positionData.candidates;
    const screening = positionData.screenings;
    const advertisements = positionData.ad;
    const detailCandidate = useSelector((state) => state.candidates.candidates);

    const [openExistingCandidateDrawer, setOpenExistingCandidateDrawer] = useState(false);
    const [filteredItems, setFilteredItems] = useState(position);
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [advertisement, setAdvertisement] = useState(advertisements)
    const [subTabIndex, setSubTabIndex] = useState({
        label: advertisement?.hiring_stage?.flow_types[0]?.flow_stages[0]?.name,
        value: 0
    });
    const [tabIndex, setTabIndex] = useState({
        label: advertisement?.hiring_stage?.flow_types[0]?.name,
        value: 0
    });
    const [candidateData, setCandidateData] = useState(null);
    const [openEmail, setOpenEmail] = useState(false);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [selectedCandidateEmail, setSelectedCandidateEmail] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCandidateItem, setSelectedItem] = useState(null)
    const [interviewerNameError, setInterviewerNameError] = useState("");
    const [interviewTimeError, setInterviewTimeError] = useState("");
    const [interviewTime, setInterviewTime] = useState({ interviewTime: "", });
    const [interviewDateError, setInterviewDateError] = useState("");
    const [interviewDate, setInterviewDate] = useState({ interviewDate: "", });
    const [description, setDescription] = useState("");
    const [finalInterview, setFinalInterview] = useState(false);
    const [meetingModeError, setMeetingModeError] = useState("");
    const [gmeetAuthenticated, setGmeetAuthenticated] = useState(true);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [state, setState] = useState({ right: false, });
    const [openScheduleDialog, setOpenScheduleDialog] = useState(false);
    const [selectedSource, setSelectedSource] = useState("");
    const [selectedExperience, setSelectedExperience] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [candidates, setCandidates] = useState(detailCandidate)
    const [interviewList, setInterviewsList] = useState([]);
    const [filteredCandidates, setFilteredCandidates] = useState(candidates);
    const [currentPage, setCurrentPage] = useState(1);
    const [nextStage, setNextStage] = useState(null);
    const [typeLabel, setTypeLabel] = useState(null);
    const candidatesPerPage = 10;

    const indexOfLastCandidate = currentPage * candidatesPerPage;
    const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
    const currentCandidates = filteredCandidates.slice(indexOfFirstCandidate, indexOfLastCandidate);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const [scheduleInterviewRecord, setScheduleInterviewRecord] = useState({
        datetime: "",
        status: 0,
        rating: 0,
        feedback: "",
        evaluated_exp: 0,
        candidate: 0,
        interviewer: [],
        mode: "online",
        meeting_link: "",
        address: "",
        timezone: "Asia/Kolkata",
    });
    
    const openAction = Boolean(anchorEl);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // useEffect for employeelist
    useEffect(() => {
        getJobAdvertisementByID();
        getListCandidates();
        getGmeetAuthenticateStatus();

        if (window.location.href.includes("code")) {
            const query = new URLSearchParams(window.location.search);
            const code = query.get("code");
            postGoogleResponseCode(code);
        }
        handleFilter(advertisement?.hiring_stage.flow_types[0]?.name);
    }, []);

    const handleOpenScheduleDialog = (candidate) => {
        // setSelectedCandidate(candidate)
        setSelectedCandidateEmail(candidate)
        setScheduleInterviewRecord((state) => ({
            ...state,
            datetime: "",
            interviewer: [],
            mode: "online",
            meeting_link: "",
            address: "",
            timezone: "Asia/Kolkata",
        }));
        setOpenScheduleDialog(true);
    };

    const handleCloseScheduleDialog = () => {
        setOpenScheduleDialog(false);
        setMeetingModeError("");
    };

    const dispatch = useDispatch();

    // Handle Email Icon click (open email dialog)
    const handleEmailIconClick = (candidate) => {
        setOpenEmail(true); // Open the email dialog
        setSelectedCandidateEmail(candidate);
    };

    const handleCloseEmail = () => {
        setOpenEmail(false);
        setSelectedCandidateEmail(null);
    };

    // useEffect(() => {
    //     if (advertisement.hiring_stage.flow_types.length > 0) {
    //         handleFilter(advertisement.hiring_stage.flow_types[0].name);
    //     }
    // }, [advertisement.hiring_stage.flow_types]);

    // Handle Tab Change

    const [filteredCandidatesData, setFilteredCandidatesData] = useState([]);

    const handleTabChange = (event, newValue) => {
        const selectedFlow = advertisement?.hiring_stage?.flow_types?.[newValue];
        const newStages = selectedFlow?.flow_stages || [];
        setTabIndex({
            value: newValue,
            label: selectedFlow?.name || "",
        });

        setSubTabIndex({
            value: newStages.length > 0 ? 0 : null,
            label: newStages.length > 0 ? newStages[0]?.name || "" : "",
        });

        setFilteredCandidatesData([]);
    };

    const handleSubTabChange = (event, newValue) => {
        const selectedSubTab = advertisement?.hiring_stage?.flow_types[tabIndex?.value]?.flow_stages?.[newValue]?.name;
        setSubTabIndex({
            value: newValue,
            label: selectedSubTab,
        });
    };

    useEffect(() => {
        const selectedFlow = advertisement?.hiring_stage?.flow_types?.[tabIndex?.value];
        if (!selectedFlow) {
            setFilteredItems([]);
            setFilteredCandidatesData([]);
            return;
        }

        const flowStages = selectedFlow?.flow_stages || [];
        const resolvedStageIndex =
            subTabIndex?.value !== null && subTabIndex?.value !== undefined ? subTabIndex.value : 0;
        const selectedStage = flowStages?.[resolvedStageIndex];
        const flowCandidates = advertisement?.candidates_job_openings?.filter(
            (job) => job?.current_flow?.name === selectedFlow?.name
        ) || [];

        setFilteredItems(flowCandidates);

        if (selectedStage) {
            setFilteredCandidatesData(
                flowCandidates.filter((job) => job?.current_stage?.name === selectedStage?.name)
            );

            if (selectedStage?.name !== subTabIndex?.label) {
                setSubTabIndex({
                    label: selectedStage?.name || "",
                    value: resolvedStageIndex,
                });
            }
        } else {
            setFilteredCandidatesData(flowCandidates);
        }
    }, [advertisement?.candidates_job_openings, advertisement?.hiring_stage, tabIndex?.value, subTabIndex?.value]);
    useEffect(() => {
        handleFilter(advertisement?.hiring_stage?.flow_types[0]?.name);
        if (
          advertisement?.position &&
          advertisements?.length > 0 &&
          newRecord.jd.length === 0
        ) {
          const matchedJD = advertisementss.find(
            (item) => item.position === advertisement.position
          );
          if (matchedJD) {
            setNewRecord((prev) => ({
              ...prev,
              jd: [matchedJD], // :point_left: default value ko state me set kar rahe
            }));
          }
        }
      }, [advertisement, advertisementss]);

    const handleFilter = (flowName) => {
        const filteredCandidates = advertisement?.candidates_job_openings.filter((item) =>
             item.current_flow?.name === flowName
        );
        setFilteredItems(filteredCandidates);
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    // const createdAt = advertisement.created_at;
    // const formattedCreatedAt = formatDate(createdAt);

    // data for other tabs except screening

    const STAGE_TYPE_OPTIONS = [
        { value: 1, label: "New" },
        { value: 2, label: "Screening" },
        { value: 3, label: "System Test" },
        { value: 4, label: "Interview" },
        { value: 5, label: "Selected" },
        { value: 6, label: "Job Offered" },
        { value: 7, label: "Onboarded" },
        { value: 8, label: "Archived" },
      ];
    const handleOpenDrawer = async (candidate) => {
        setSelectedCandidate(candidate);
    
        const res = await ApiCalls.getCandidateInterviews(candidate?.candidate?.id, `?job_opening_id=${advertisement?.id}`);
        if (res.success && res.code == 200) {
            setInterviewsList(res.data);
        }
    
        const currentStage = candidate?.current_stage;
        const currentFlow = candidate?.current_flow;
    
        const nextStage = currentFlow?.flow_stages?.find(
            stage => stage.sequence === currentStage.sequence + 1
        );
        if (nextStage) {
            // currentFlow.type is the type ID (e.g., 1, 2, etc.)
            let typeLabel = STAGE_TYPE_OPTIONS.find(
                item => item.value === currentFlow.type
            )?.label;
            setNextStage(nextStage)
            setTypeLabel(typeLabel);
        }
    
        setOpenDrawer(true);
    };

    // Function to close drawer
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
        setSelectedCandidate(null);
    };

    // function to handle action
    const handleActionClick = (event, candidate) => {
        setAnchorEl(event.currentTarget);
        setSelectedCandidate(candidate);
    };

    const handleCloseAction = () => {
        setAnchorEl(null);
    };

    //  function to handle drawer
    const toggleDrawer = (open) => (event) => {
        if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState((prevState) => ({ ...prevState, right: open }));
    };


    const employee = useSelector((state) => state.employee.employee);

    async function getJobAdvertisementByID() {
        // const user = JSON.parse(localStorage.getItem("user"));
        var res = await ApiCalls.getJobAdvertisement(advertisement?.id);

        if (res.success && res.code == 200) {
            setAdvertisement(res.data);
        } else {
        }
    }
    
    // const employee = JSON.parse(localStorage.getItem("Employee_Data"));
    
    const employeesList = useSelector((state) => state.employee.employee);


    const [loading, setLoading] = useState(false);
    // Get candidate list API
    async function getListCandidates(queryParams) {
        const res = await ApiCalls.getCandidatesList(queryParams);
        if (res.success && res.code == 200) {
            dispatch(candidatesList({ candidates: res.data }));
            setCandidates(res.data)
        } else {
        }
    }
    // schedule interview api
    const handleScheduleInterview = async () => {
        let hasError = false;
        let error = "This field may not be blank.";
        const interviewerId = scheduleInterviewRecord?.interviewer?.map((interviewer) => interviewer?.id);
        var payload = {
            interviewer: interviewerId,
            candidate: selectedCandidate?.candidate?.id,
            datetime: handleInputDateTimeInterviewChange(
                scheduleInterviewRecord.datetime
            ),
            meeting_note: description,
            final_interview: finalInterview,
            job_opening: selectedCandidate.id,
            flow : selectedCandidate?.current_flow?.id,
            stage : selectedCandidate?.current_stage?.id,
            mode: scheduleInterviewRecord.mode,
            timezone: scheduleInterviewRecord.timezone || "Asia/Kolkata",
        };

        if (scheduleInterviewRecord.mode === "online") {
            payload.meeting_link = scheduleInterviewRecord.meeting_link;
        } else {
            payload.address = scheduleInterviewRecord.address;
        }

        if (
            !scheduleInterviewRecord.datetime
        ) {
            setInterviewDateError(error);
            setInterviewTimeError(error);
            hasError = true;
        } else {
            setInterviewDateError("");
            setInterviewTimeError("");
        }
        if (scheduleInterviewRecord.interviewer.length === 0) {
            setInterviewerNameError(error);
            hasError = true;
        } else {
            setInterviewerNameError("");
        }
        if (
            (scheduleInterviewRecord.mode === "online" && !scheduleInterviewRecord.meeting_link?.trim()) ||
            (scheduleInterviewRecord.mode === "offline" && !scheduleInterviewRecord.address?.trim())
        ) {
            setMeetingModeError(
                scheduleInterviewRecord.mode === "online"
                    ? "Meeting link is required for online interviews."
                    : "Address is required for offline interviews."
            );
            hasError = true;
        } else {
            setMeetingModeError("");
        }

        if (!hasError) {
            // if(payload.candidate && payload.datetime && payload.interviewer){
            const res = await ApiCalls.postInterview(payload, true);
            if (res.success && res.code == 201) {
                handleCloseScheduleDialog();
                getListCandidates();
            } else if (res.success == false && res.code == 400) {
            } else {
            }
            // getListCandidates();
        }
    };

    const getGmeetAuthenticateStatus = async () => {
        var res = await ApiCalls.getStatusOfGoogleAuthenticate();
        setGmeetAuthenticated(res.success ? true : false);
    };

    // const backdropStyles = { backgroundColor: "rgba(0, 0, 0, 0.06) !important" };




    const handleExistingCandidateDrawer = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setOpenExistingCandidateDrawer(true);
        }, 1000);
    };

    const handleCloseExistingCandidateDrawer = () => {
        setOpenExistingCandidateDrawer(false);
    };

    const handleToggleCandidate = (id) => {
        setSelectedCandidates((prev) =>
            prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]
        );
    };

    const handleProcessCandidates = async () => {


        if (selectedCandidates.length === 0) return;

        // setLoading(true); // Show loading state
        try {
            const response = await ApiCalls.attachCandidatesToAdvertisement(advertisement?.id, {
                candidate_ids: selectedCandidates,
            });

            if (!response?.success) {
                throw new Error("Failed to attach candidates");
            }
            getJobAdvertisementByID()
            handleCloseExistingCandidateDrawer()

            // alert("Candidates attached successfully!");

            setSelectedCandidates([]); // Clear selection after success
            // onClose(); // Close the drawer
        } catch (error) {
            console.error("Error attaching candidates:", error);
            alert("Failed to attach candidates. Please try again.");
        }
        // setLoading(false);
    };

    const handleMoveToNextStage = async (candidate, setCandidates) => {

        if (!candidate || !candidate.id || !candidate.job_openings?.length) {
            console.error("Invalid candidate data");
            alert("Candidate data is missing or incorrect.");
            return;
        }
        const jobOpeningId = advertisement?.id;

        try {
            const response = await ApiCalls.moveCandidateToNextFlow(candidate.id, {
                job_opening: jobOpeningId,
            });

            if (!response?.success) {
                throw new Error(response?.message || "Failed to move candidate.");
            }

            const responseData = response.data;
            setCandidates(prevCandidates =>
                prevCandidates.map(c =>
                    c.id === candidate.id ? { ...c, current_stage: responseData.new_stage } : c
                )
            );
            handleCloseDrawer()
            getJobAdvertisementByID();

        } catch (error) {
            console.error("Error moving candidate:", error);
            alert("Failed to move candidate. Please try again.");
        }
    };

    const sourceOptions = Array.from(new Set(candidates.map(c => c.source)));
    const experienceOptions = [1, 3, 5];
    useEffect(() => {
        let filteredList = candidates;
        if (selectedSource) {
            filteredList = filteredList.filter(candidate => candidate.source === selectedSource);
        }
        if (selectedExperience) {
            filteredList = filteredList.filter(candidate => Math.floor(candidate.experience) === selectedExperience);
        }
        if (searchQuery) {
            filteredList = filteredList.filter(candidate =>
                candidate.full_name.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
        setFilteredCandidates(filteredList);
    }, [selectedSource, selectedExperience, searchQuery, candidates]); // Runs every time a filter value or candidates list changes


    const backButton = () => {
        setIsCard(false);
        // setDialogOnButtonClick(false);
        setJobAdvertisementPayload('')
    }

    const handleOnScheduleInterview = (row) => {
        setScheduleInterviewRecord((state) => ({
            ...state,
            candidate: row.id || "",
            evaluated_exp: row.experience || "",
            status: row.status || "",
        }));

        setScheduleInterviewOpen(true);
    };

    const handleInputDateTimeInterviewChange = (selectedDateTime) => {
        if (!selectedDateTime) {
            return "";
        }

        const dateObject = new Date(selectedDateTime);
        return dateObject.toISOString();
    };
    const fullName = `${employee?.find(item => item.id === advertisement.created_by)?.user.firstname} ${employee?.find(item => item.id === advertisement.created_by)?.user.lastname}`;

    const [showAlert, setShowAlert] = useState(null);
    const [candidateNameDialog, setCandidateNameDialog] = React.useState(false);
    const employeeOptions = employeesList.map((employee) => ({
        value: `${employee.id}`,
        label: `${employee.user.firstname} ${employee.user.lastname}`,
    }));
    var advertisementss = useSelector((state) =>
        state.jobAdvertisement.jobAdvertisement
    );
    const detail = useSelector((state) => state.candidates.details);
    const [newRecord, setNewRecord] = useState({
        full_name: "",
        mobile: "",
        email: "",
        experience: "",
        status: "",
        source: "",
        jd: [],
        recruiter: [],
        cv: "",
    });
    const handleAddRecord = async (file) => {
        let hasError = false;
        let error = "This field may not be blank.";
        if (newRecord.full_name === undefined || newRecord.full_name === "") {
            setFullNameError(error);
            hasError = true;
        } else {
            setFullNameError("");
        }
        if (newRecord.mobile === undefined || newRecord.mobile === "") {
            setNumberError(error);
            hasError = true;
        } else {
            setNumberError("");
        }
        if (newRecord.experience === undefined || newRecord.experience === "") {
            setExperienceError(error);
            hasError = true;
        } else {
            setExperienceError("");
        }
        if (newRecord.email === undefined || newRecord.email === "") {
            setEmailError(error);
            hasError = true;
        } else {
            setEmailError("");
        }
        if (resume === null) {
            setCVError("please select file");
            hasError = true;
        } else {
            setCVError("");
        }
        if (newRecord.source === undefined || newRecord.source === "") {
            setSourceError(error);
            hasError = true;
        } else {
            setSourceError("");
        }
        // if (newRecord.jd === undefined || newRecord.jd === "") {
        //     setJDError(error);
        //     hasError = true;
        // } else {
        //     setJDError("");
        // }
        if (newRecord.status === undefined || newRecord.status === "") {
            setStatusError(error);
            hasError = true;
        } else {
            setStatusError("");
        }
        if (
            newRecord.id &&
            newRecord.full_name &&
            newRecord.mobile &&
            newRecord.experience &&
            newRecord.email &&
            newRecord.status &&
            newRecord.source &&
            newRecord.recruiter &&
            newRecord.cv 
            // newRecord.jd
        ) {
            const newDataRow = createData(
                newRecord.id,
                newRecord.full_name,
                newRecord.mobile,
                newRecord.experience,
                newRecord.email,
                newRecord.status,
                newRecord.source,
                newRecord.recruiter,
                newRecord.cv,
                // newRecord.jd
            );
            setRows([...rows, newDataRow]);
            setNewRecord({
                id: "",
                full_name: "",
                mobile: "",
                email: "",
                experience: "",
                status: "",
                source: "",
                cv: "",
                // jd: ""
            });
        }
        const formData = new FormData();
        formData.append("cv", resume);
        formData.append("full_name", newRecord.full_name);
        formData.append("mobile", newRecord.mobile);
        formData.append("email", newRecord.email);
        formData.append("experience", newRecord.experience);
        formData.append("source", newRecord.source);
        formData.append("status", newRecord.status);
        // const jobIds = newRecord.jd ? newRecord.jd.map((job) => job.id) : [];
        // formData.append("job_ad", '');
        formData.append("recruiter", newRecord.recruiter);
        if (!hasError) {
            const res = await ApiCalls.postCandidate(formData, true, true);
            const newActiveStep =
                isLastStep() && !allStepsCompleted()
                    ? // It's the last step, but not all steps have been completed, find the first step that has been completed
                    steps.findIndex((step, i) => !(i in completed))
                    : activeStep + 1;
            setActiveStep(newActiveStep);
            if (res.success && res.code == 201) {
                setCandidateData(res.data);
                getListCandidates();
                // handleRecordsClose();
                setNewRecord({});
            } else {
                if (res.code === 400) {
                    setShowAlert("Please enter the data");
                    const errors = res.data;
                    if (errors.full_name) {
                        alert(errors.full_name);
                    } else if (errors.experience) {
                        alert(errors.experience);
                    } else if (errors.email) {
                        alert(errors.email);
                    } else if (errors.job_ad) {
                        alert(errors.job_ad);
                    } else if (errors.cv) {
                        alert(errors.cv);
                    } else if (errors.source) {
                        alert(errors.source);
                    }
                    else if (errors.jd) {
                        alert(errors.jd);
                    } else if (errors.status) {
                        alert(errors.status);
                    }
                }
            }
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewRecord((prevState) => ({ ...prevState, [name]: value }));
        if (name === "full_name") {
            setFullNameError("");
        } else if (name === "email") {
            setEmailError("");
        } else if (name === "experience") {
            setExperienceError("");
        }
    };
    const [recordsOpen, setRecordsOpen] = React.useState(false);
    const [editableRowIndex, setEditableRowIndex] = useState(-1);
    const [editedData, setEditedData] = useState([]);
    const alertContent = (name) => (
        <MDTypography variant="body2" color="white">
            {name}
        </MDTypography>
    );
    const [fullNameError, setFullNameError] = useState("");
    const [numberError, setNumberError] = useState("");
    const [experienceError, setExperienceError] = useState("");
    const [jdError, setJDError] = useState("");
    const [cvError, setCVError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [sourceError, setSourceError] = useState("");
    const [statusError, setStatusError] = useState("");
    const handleRecordsOpen = () => {
        setEditableRowIndex(-1);
        setRecordsOpen(true);
    };
    const handleRecordsClose = () => {
        setRecordsOpen(false);
    };
    const handleFieldChange = (event, fieldName) => {
        const updatedData = [...editedData];
        const editedRecord = { ...updatedData[editableRowIndex] };
        editedRecord[fieldName] = event.target.value;
        updatedData[editableRowIndex] = editedRecord;
        setEditedData(updatedData);
    };
    const handleEditClick = (row, actualIndex) => {
        setEditableRowIndex(actualIndex);
        setEditedData([...data]);
        setID(row.id);
    };
    const handleSaveClick = async () => {
        const editedRow = editedData?.find((row) => row.id === id_);
        const formData = new FormData();
        if (resume) {
            formData.append("cv", resume);
        }
        if (selectedValues) {
            const docs = selectedValues?.map((key) => parseInt(key, 10));
            docs.forEach((doc) => {
                formData.append("documents_needed", doc);
            });
        }
        if (editedRow !== undefined) {
            formData.append("full_name", editedRow.full_name);
            formData.append("mobile", editedRow.mobile);
            formData.append("email", editedRow.email);
            formData.append("experience", editedRow.experience);
            formData.append("status", editedRow.status);
            formData.append("source", editedRow.source);
            editedRow?.job_ad != null && editedRow?.job_ad != undefined ? formData.append("job_ad", editedRow?.job_ad) : null;
            formData.append("recruiter", parseInt(editedRow.recruiter));
        }
        const res = await ApiCalls.updateCandidate(id_, formData, true);
        if (res.success && res.code == 200) {
            setCandidateNameDialog(false);
            setData(editedData);
            getListCandidates();
            setEditableRowIndex(null);
        } else {
            setCandidateNameDialog(false);
        }
    };
    const handleCancelClick = () => {
        setEditableRowIndex(-1);
    };
    const [resume, setResume] = useState(null);
    const handleFileSelect = async (e) => {
        const file = e.target.files[0];
        let extension = file.name.split(".").pop();
        if (extension == "pdf" || extension == "docx") {
            setResume(file);
            setCVError("");
        } else {
            alert("Only PDF or DOCX Are Allowed ");
        }
    };
    // Get status and source api
    useEffect(() => {
        getOptionValue();
    }, []);
    const [option, setOption] = useState({});
    async function getOptionValue() {
        const res = await ApiCalls.getCandiateStatusAndSource();
        if (res.success && res.code == 200) {
            setOption(res.data);
            dispatch(optionValues({ candidates: res.data }));
        } else {
        }
    }
    const candidateOptionValues = useSelector(
        (state) => state.candidates.options.candidates
    );
    function convertSource(so) {
        const sourceValue = candidateOptionValues?.source[so] || "";
        return `${sourceValue}`;
    }
    function convertStatus(st) {
        const statusValue = candidateOptionValues?.status[st] || "";
        return `${statusValue}`;
    }

    const [activeStep, setActiveStep] = React.useState(0);
    const steps = ['Candidate Information', 'JOB Openings'];
    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };
    const handleNext = () => {
        // if (!validateCurrentStep()) {
        //     return; // Stop if validation fails
        // }
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed, find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        setActiveStep(newActiveStep);
    };
    const totalSteps = () => {
        return steps.length;
    };
    const [completed, setCompleted] = React.useState({});
    const completedSteps = () => {
        return Object.keys(completed).length;
    };
    const handleStep = (step) => () => {
        setActiveStep(step);
    };
    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };
    const handleReset = () => {
        setActiveStep(0);
        setCompleted({});
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleJobOpenings = async () => {
        try {
            const jobIds = (Array.isArray(newRecord.jd) && newRecord.jd.length > 0)
            ? newRecord.jd.map(job => job.id)
            : [advertisements.id];
            const payload = {
                job_opening_ids : jobIds
            }
            if (candidateData?.id) {
                const candidateId = candidateData?.id;
                const res = await ApiCalls.postJobOpenings(payload, candidateId, true, true);
                handleRecordsClose();
								getJobAdvertisementByID()
            } else {

                console.error("Failed to get candidate ID:");
            }
        } catch (error) {
            console.error("Error in handleJobOpenings:", error);
        }
    };
    const isSmallScreenJOBOpenings = useMediaQuery("(max-width:600px)");
    const isMediumScreen = useMediaQuery("(max-width:900px)");


    return (
        <div>
            {/* <DashboardLayout> */}
            {/* <DashboardNavbar /> */}
            {/*<Card>*/}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexWrap: "wrap", borderRadius: 2, marginTop: '12px', marginBottom: '12px', boxShadow: 1, alignItems: "center", gap: "50px"
                    }}
                >
                    <Box sx={{display : 'flex', justifyContent : 'center', alignItems : 'center', gap: .5 }}>
											 	<Box
														sx={{
															width: 48,
															height: 48,
															borderRadius: "16px",
															display: "grid",
															placeItems: "center",
                    					//background: `linear-gradient(135deg, ${colors.light.main} 0%, ${colors.info.main} 100%)`,
														  color: colors.info.focus,
															cursor : 'pointer'
														}}
														onClick={backButton}
													>
														<Icon fontSize='54px'><ChevronLeft /></Icon>
														
													</Box>
											  <Box>
													<Typography variant='body2'>Profile</Typography>
                          <Typography variant="h4" fontWeight="bold">{advertisement.position}</Typography>
												</Box>
                        
                    </Box>
                    <Box display='flex' justifyContent='space-between'>
                        {fullName !== 'undefined undefined' && 
                            <Box>
                                <Typography variant='body2'>Created By</Typography>
                                <Typography variant="h5" fontWeight="bold">{fullName || "Unknown"}</Typography>
                            </Box>
                        }
                        {/* {advertisement.hiring_stage.name && <Box>
                        <Typography variant='body2' color='text.secondary'>Flow Name</Typography>
                        <Typography variant="h5" fontWeight="bold">{ advertisement.hiring_stage.name || "Not Available"}</Typography>
                    </Box>} */}
                        {/* <Typography variant='h3'>{advertisement.hiring_stage.name}</Typography> */}
                    </Box>

                    <Box display="flex" gap={2}>
                        {permissions?.includes(modulePermissions?.candidate?.create_permission) && (
                            // <Box display="flex" gap={2}>
                            <MDButton
                                //variant="contained"
                                color="info"
                                onClick={handleRecordsOpen}
                                // onClick={handleExistingCandidateDrawer}
                                // onClick={handleAddCandidate}
                                sx={{ textTransform: "none" }}
                            >
                                Add New Candidate
                            </MDButton>
                            // </Box>
                        )}
                        <MDButton
                            //variant="contained"
                            color="info"
                            onClick={handleExistingCandidateDrawer}
                            sx={{ textTransform: "none" }}
                        >
                            Add Existing Candidate
                        </MDButton>
                    </Box>
                </div>
                {advertisement?.hiring_stage?.flow_types?.length > 0 &&
                    <Card sx={{ backgroundColor : colors.background.elevated, p:2 }}>
                        <Box>
                            <CardContent >
                                {advertisement.hiring_stage.name && <Box marginBottom='10px'>
                                    <Typography variant='body2'>Flow Name</Typography>
                                    <Typography variant="h5" fontWeight="bold">{advertisement.hiring_stage.name || "Not Available"}</Typography>
                                </Box>}
                                <Box sx={{ border: "none", display: "flex", flexDirection: isSmallScreen ? "column" : "row", alignItems: "center", justifyContent: isSmallScreen ? "flex-start" : "center", gap: 1 }}>
                                    <Tabs value={tabIndex?.value}
                                        onChange={handleTabChange}
                                        centered={!isSmallScreen} orientation={isSmallScreen ? "vertical" : "horizontal"} sx={{
                                            width: "100%",
                                            "& .MuiTab-root": {
                                                fontSize: isSmallScreen ? "0.8rem" : "1rem",
                                            },
                                        }}>
                                        {advertisement.hiring_stage.flow_types?.map((item, index) => {
                                            return (
																							<Tab
																								key={index}
																								label={item?.name} sx={{
																									minHeight: 46,
																									borderRadius: "14px",
																									px: 2.1,
																									py: 0.8,
																									textTransform: "none",
																									color: colors.text.main,
																									fontWeight: 700,
																									transition: "all 180ms ease",
																									"& .MuiTab-iconWrapper": {
																										mb: "0 !important",
																									},
																									"&:hover": {
																										backgroundColor: rgba(colors.background.muted, 0.42),
																										color: colors.dark.main,
																									},
																									"&.Mui-selected": {
																										color: colors.dark.main,
																										background: `linear-gradient(335deg, ${colors.light.main} 0%, ${colors.info.main} 150%)`,
																										boxShadow: `0 10px 22px ${rgba(colors.dark.main, 0.08)}`,
																									},
																								}} />
                                            )
                                        })}
                                    </Tabs>
                                </Box>
                            </CardContent>
                        </Box>
                        {advertisement?.hiring_stage?.flow_types[tabIndex?.value]?.flow_stages?.length > 0 &&

                            //<Card sx={{margin : "14px"}}>
                                <Box>
                                    <CardContent >
                                        <Typography variant='h6' marginBottom='10px'>Flow Stages</Typography>
                                        <Box sx={{border: "none", display: "flex", flexDirection: isSmallScreen ? "column" : "row", alignItems: "center", justifyContent: isSmallScreen ? "flex-start" : "center", gap: 1 }}>
                                            <Tabs value={subTabIndex?.value}
                                                onChange={handleSubTabChange}
                                                centered={!isSmallScreen} orientation={isSmallScreen ? "vertical" : "horizontal"} sx={{
                                                    width: "100%",
                                                    "& .MuiTab-root": {
                                                        fontSize: isSmallScreen ? "0.8rem" : "1rem",
                                                    },
                                                }}>
                                                {advertisement?.hiring_stage?.flow_types[tabIndex?.value]?.flow_stages?.map((item, index) => {
                                                    return (
                                                        <Tab 
																												key={index} 
																												label={item?.name} 
																												sx={{
																													minHeight: 46,
																													borderRadius: "14px",
																													px: 2.1,
																													py: 0.8,
																													textTransform: "none",
																													color: colors.text.main,
																													fontWeight: 700,
																													transition: "all 180ms ease",
																													"& .MuiTab-iconWrapper": {
																														mb: "0 !important",
																													},
																													"&:hover": {
																														backgroundColor: rgba(colors.background.muted, 0.42),
																														color: colors.dark.main,
																													},
																													"&.Mui-selected": {
																														color: colors.dark.main,
																														background: `linear-gradient(335deg, ${colors.light.main} 0%, ${colors.info.main} 150%)`,
																														boxShadow: `0 10px 22px ${rgba(colors.dark.main, 0.08)}`,
																													},}}
																												/>
                                                    )
                                                })}
                                            </Tabs>
                                        </Box>
                                    </CardContent>
                                </Box>
                            //</Card>
												}
                    
                <RenderCandidatesList
                    filteredItems={filteredItems}
                    filteredCandidatesData={filteredCandidatesData}
                    anchorEl={anchorEl}
                    openAction={openAction}
                    handleCloseAction={handleCloseAction}
                    isSmallScreen={isSmallScreen}
                    state={state}
                    toggleDrawer={toggleDrawer}
                    selectedCandidateItem={selectedCandidateItem}
                    detailCandidate={detailCandidate}
                    handleOpenScheduleDialog={handleOpenScheduleDialog}
                    handleOpenDrawer={handleOpenDrawer}
                    handleActionClick={handleActionClick}
                    selectedCandidate={selectedCandidate}
                    selectedCandidateEmail={selectedCandidateEmail}
                    handleEmailIconClick={handleEmailIconClick}
                    setSelectedItem={setSelectedItem}
                />
                <CandidateDetails
                    nextStageTypeLabel={typeLabel}
                    nextStage = {nextStage}
                    openDrawer={openDrawer}
                    handleCloseDrawer={handleCloseDrawer}
                    selectedCandidate={selectedCandidate}
                    handleMoveToNextStage={handleMoveToNextStage}
                    setCandidates={setCandidates}
                    handleOpenScheduleDialog={handleOpenScheduleDialog}
                    setOpenDrawer={setOpenDrawer}
                    interviewList={interviewList}
                    employeeOptions={employeeOptions}
                    option={option}
                />

                {/* Email Dialog */}
                <EmailDialog
                    openEmail={openEmail}
                    handleCloseEmail={handleCloseEmail}
                    selectedCandidateEmail={selectedCandidateEmail}
                />

                {/* Dialog Box for Schedule Interview */}
                <ScheduleInterviewDialog
                    openScheduleDialog={openScheduleDialog}
                    handleCloseScheduleDialog={handleCloseScheduleDialog}
                    employeesList={employeesList}
                    interviewTimeError={interviewTimeError}
                    interviewTime={interviewTime}
                    interviewDateError={interviewDateError}
                    interviewDate={interviewDate}
                    description={description}
                    finalInterview={finalInterview}
                    selectedCandidate={selectedCandidate}
                    interviewerNameError={interviewerNameError}
                    setScheduleInterviewRecord={setScheduleInterviewRecord}
                    setInterviewerNameError={setInterviewerNameError}
                    setInterviewTime={setInterviewTime}
                    setInterviewTimeError={setInterviewTimeError}
                    setInterviewDate={setInterviewDate}
                    setInterviewDateError={setInterviewDateError}
                    setDescription={setDescription}
                    setFinalInterview={setFinalInterview}
                    gmeetAuthenticated={gmeetAuthenticated}
                    handleScheduleInterview={handleScheduleInterview}
                    scheduleInterviewRecord={scheduleInterviewRecord}
                    meetingModeError={meetingModeError}
                    setMeetingModeError={setMeetingModeError}
                />

                {/* Dialog Box for Add Candidates */}
                <AddCandidateDialog
                    recordsOpen={recordsOpen}
                    handleRecordsClose={handleRecordsClose}
                    activeStep={activeStep}
                    isSmallScreen={isSmallScreen}
                    steps={steps}
                    completed={completed}
                    handleStep={handleStep}
                    allStepsCompleted={allStepsCompleted}
                    showAlert={showAlert}
                    newRecord={newRecord}
                    handleInputChange={handleInputChange}
                    fullNameError={fullNameError}
                    numberError={numberError}
                    emailError={emailError}
                    experienceError={experienceError}
                    candidateOptionValues={candidateOptionValues}
                    convertSource={convertSource}
                    employeesList={employeesList}
                    editedData={editedData}
                    editableRowIndex={editableRowIndex}
                    convertStatus={convertStatus}
                    cvError={cvError}
                    handleFileSelect={handleFileSelect}
                    totalSteps={totalSteps}
                    handleBack={handleBack}
                    handleAddRecord={handleAddRecord}
                    sourceError={sourceError}
                    statusError={statusError}
                    setNewRecord={setNewRecord}
                    setSourceError={setSourceError}
                    setStatusError={setStatusError}
                    advertisementss={advertisementss}
                    handleJobOpenings={handleJobOpenings}
                    jdError={jdError}
                    advertisement={advertisement}
                    isSmallScreenJOBOpenings={isSmallScreenJOBOpenings}
                    isMediumScreen={isMediumScreen}
                />

                {/* Dialog Box for details */}
                <CandidateInformationDialog
                    candidateNameDialog={candidateNameDialog}
                    editedData={editedData}
                    editableRowIndex={editableRowIndex}
                    candidateOptionValues={candidateOptionValues}
                    convertStatus={convertStatus}
                    convertSource={convertSource}
                    employeeOptions={employeeOptions}
                    advertisements={advertisements}
                    handleFileSelect={handleFileSelect}
                    detail={detail}
                    permissions={permissions}
                    modulePermissions={modulePermissions}
                    jdError={jdError}
                    handleFieldChange={handleFieldChange}
                    setJDError={setJDError}
                    handleCancelClick={handleCancelClick}
                    setCandidateNameDialog={setCandidateNameDialog}
                    handleSaveClick={handleSaveClick}
                />

                <ExistingCandidateList
                    openExistingCandidateDrawer={openExistingCandidateDrawer}
                    handleCloseExistingCandidateDrawer={handleCloseExistingCandidateDrawer}
                    handleProcessCandidates={handleProcessCandidates}
                    selectedCandidates={selectedCandidates}
                    selectedExperience={selectedExperience}
                    experienceOptions={experienceOptions}
                    selectedSource={selectedSource}
                    sourceOptions={sourceOptions}
                    candidates={candidates}
                    filteredCandidates={filteredCandidates}
                    currentCandidates={currentCandidates}
                    candidatesPerPage={candidatesPerPage}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                    setSelectedSource={setSelectedSource}
                    setSelectedExperience={setSelectedExperience}
                    handleToggleCandidate={handleToggleCandidate}
                    setSearchQuery={setSearchQuery}
                    loading={loading}
                />

								</Card>}
            {/*</Card>*/}
            {/* </DashboardLayout> */}
        </div>
    );
}

export default Position;
